import { extendCrudApiByHousehold } from '@/utils/api.js';

const invalidatesTagsAndRecipes = (result, error, arg) => [
  { type: 'Tags', id: arg.id, householdId: arg.householdId },
  { type: 'Tags', id: 'LIST', householdId: arg.householdId },
  { type: 'Recipes', id: 'LIST', householdId: arg.householdId },
];

const tagsApi = extendCrudApiByHousehold({
  entityNameSingular: 'Tag',
  entityNamePlural: 'Tags',
  entityPath: 'tags',
  extraTags: ['Recipes'],
  extraEndpoints: (builder) => ({
    updateTag: builder.mutation({
      query: ({ householdId, id, data }) => ({
        url: `/h/${householdId}/tags/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: invalidatesTagsAndRecipes,
    }),
    deleteTag: builder.mutation({
      query: ({ householdId, id }) => ({
        url: `/h/${householdId}/tags/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: invalidatesTagsAndRecipes,
    }),
  }),
});

export const {
  useGetTagsQuery,
  useGetTagQuery,
  useCreateTagMutation,
  useUpdateTagMutation,
  useDeleteTagMutation,
} = tagsApi;

